import styled, { css } from 'styled-components';
import { COLORS, SIZING } from '../../styles/variables';

interface StyleProps {
  disabled?: boolean;
}

export const CheckboxWrapper = styled.div<{ disabled?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  &:hover {
    [role='checkbox'] {
      border-color: ${({ disabled }) => (disabled ? '' : COLORS.black)};
    }
  }

  ${({ disabled }: StyleProps) =>
    disabled &&
    css`
      cursor: not-allowed;
    `};
`;

export const Checkbox = styled.div<{ checked?: boolean; disabled?: boolean }>`
  width: 20px;
  height: 20px;
  border: 1px solid
    ${({ checked, disabled }) => {
      if (checked) {
        return COLORS.black; // checked
      }
      if (disabled) {
        return COLORS.grey30; // disabled
      }
      return COLORS.grey60; // default
    }};
  margin: 0 ${SIZING.unit(1.5)} 0 0;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background: transparent;
  &:hover {
    border-color: ${({ checked, disabled }) => (checked || disabled ? '' : COLORS.black)};
  }
  &:focus {
    outline: ${SIZING.unit(0.5)} auto Highlight;
    outline: ${SIZING.unit(0.5)} auto -webkit-focus-ring-color;
    ${({ disabled }) =>
      disabled &&
      css`
        outline: none;
      `};
  }
`;

export const Label = styled.label<{ disabled?: boolean }>`
  display: inline;
  font-family: Audi Type;
  font-size: 16px;
  line-height: 24px;
  color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.grey80)};
  letter-spacing: 0.003px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const Hint = styled.div<{ disabled?: boolean }>`
  color: ${({ disabled }) => (disabled ? COLORS.grey30 : COLORS.grey60)};
  display: inline;
`;

export const HiddenInput = styled.input`
  display: none;
`;
